module.exports = __webpack_public_path__ + "img/bitcoin-btc-logo.120ddee1.svg";